module.exports = __webpack_public_path__ + "img/first-day-3.f3be6d56.png";